import type { SizeType } from "antd/es/config-provider/SizeContext";
import { StripeElementsOptions } from "@stripe/stripe-js";

/** Shared size for all antd Button / Input components inside the appointment modal. */
export const MODAL_COMPONENT_SIZE: SizeType = "large";

export const LOOKUP_PHONE_NUMBER = "lookup";
export const SETUP_PAYMENT = "setup-payment";
export const FIRST_TIME_CLIENT = "first-time-client";
export const VERIFY_REPEAT_CLIENT = "verify-repeat-client";
export const RESCHEDULE_MAIN = "reschedule-main";
export const RESCHEDULE_LIST = "reschedule-list";
export const CONFIRMATION = "confirmation";

export const STRIPE_ELEMENTS_OPTIONS: StripeElementsOptions = {
  appearance: { theme: "stripe" },
  mode: "setup",
  currency: "usd",
  paymentMethodTypes: ["card"],
};
